import { download } from "../../js/post";
import { userData } from "../../js/utils";

export const exportToFile = async (
  title,
  subtitles,
  addTables,
  showNumReferences,
  type,
  tables,
  emailIdOptic,
  emailTo,
) => {
  const report = {
    tituloInforme: title,
    subtitulos: subtitles,
    sumarTablas: addTables,
    mostrarNumReferencias: showNumReferences,
    tablas: tables,
  };

  return download("GenerarInforme.php", {
    token: userData.token,
    tipo: type,
    idOpticaEmail: emailIdOptic,
    destinatarioEmail: emailTo,
    informe: report,
  });
};
